/** @typedef {"customer" | "agent" | "admin"} ViewMode */
/** @typedef {"BASIC" | "PRO" | "AGENCY"} PackageTier */

export const VIEW_MODES = /** @type {const} */ (["customer", "agent", "admin"]);

export const PACKAGE_TIERS = /** @type {const} */ (["BASIC", "PRO", "AGENCY"]);

export const DEV_VIEW_MODE_STORAGE_KEY = "hr.devViewMode";

export const DEV_PACKAGE_TIER_STORAGE_KEY = "hr.devPackageTier";

export const VIEW_MODE_LABELS = {
  customer: "Customer",
  agent: "Agent",
  admin: "Admin",
};

export const PACKAGE_TIER_LABELS = {
  BASIC: "BASIC",
  PRO: "PRO",
  AGENCY: "סוכנות",
};
